import { useState } from 'react';

const useChipWrapper = () => {
  const WrapComponent = (component, type) => {
    const [showLabel, setShowLabel] = useState(false);
    // const [clicked, setClicked] = useState(false); // Track if it's clicked

    const handleMouseEnter = () => {
      // if (!clicked)
      setShowLabel(true);
    };

    const handleMouseLeave = () => {
      // if (!clicked)
      setShowLabel(false);
    };

    // const handleClick = () => {
    //   setClicked(!clicked);
    //   setShowLabel(!clicked); // Toggle visibility
    // };
    return (
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        // onClick={handleClick}
        style={{ position: 'relative' }}
      >
        {showLabel ? (
          <span
            style={{
              position: 'absolute',
              top: -23,
              height: 24,
              color: 'white',
              background: 'black',
              borderRadius: '4px',
              fontSize: 10,
              display: 'flex',
              alignItems: 'center',
              padding: '0 6px',
              zIndex: 1000,
            }}
          >
            <p>{type}</p>
          </span>
        ) : null}
        {component}
      </div>
    );
  };
  return { wrapComponent: WrapComponent };
};

export default useChipWrapper;
